import axios from '@axios'

export default {
  namespaced: true,
  state: {
    menus: [],
  },
  getters: {
    menus: state => state.menus,
  },
  mutations: {},
  actions: {
    fetchMenus(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/menus', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchMenu(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/menus/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteMenu(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/menus/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addMenu(ctx, menusData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/menus', menusData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updatedMenu(ctx, menusData) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/menus/${menusData.id_menu}`, menusData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
